import { networkAction } from "helpers/network/networkAction";

import { CALLBACK } from "constants/callbacks";

import * as Api from "api";

export const callback = (project, body) => async (dispatch) =>
  networkAction(dispatch, CALLBACK, Api.callback, [project, body]);
